import React from 'react';

import { Image, List, ListItem, Text, VStack } from '@chakra-ui/react';

import * as images from '../images';

import {
  HeadingText,
  SubtitleText,
  HighlightedText,
  ParagraphText,
  Section,
} from './commonComponents';
import SignUpButton from './SignUpButton';
import { TopPageVariant } from './types';

type PropsType = {
  variant: TopPageVariant;
  scrollToForm: () => void;
};

const ReasonSection = ({ variant, scrollToForm }: PropsType): JSX.Element => (
  <Section bgColor="#eef8fa">
    <HeadingText>
      リケイマッチが選ばれる
      <br />
      <HighlightedText fontSize="4xl">3つの理由</HighlightedText>
      <SubtitleText>reason</SubtitleText>
    </HeadingText>
    <List
      display="flex"
      justifyContent={{ base: 'center', sm: 'space-around' }}
      gap={{ base: '50px', sm: 'unset' }}
      flexWrap={{ base: 'wrap', sm: 'nowrap' }}
      maxW="95%"
      margin="auto"
      paddingTop="60px"
      textAlign="center"
    >
      <ListItem
        w="100%"
        maxW="320px"
        borderRadius="20px"
        padding="20px"
        mr="5px"
        filter="drop-shadow(0 0 10px rgba(0,0,0,.05))"
        bg="white"
      >
        <Image
          src={images.square1}
          width="56px"
          alt=""
          display="block"
          margin="-48px auto .8em"
        />
        <ParagraphText fontSize="1.2rem" as="h2">
          自社内開発
          <br />
          準大手・中小・ベンチャーが利用
        </ParagraphText>
        <Image src={images.casualOffice} width="280px" alt="" py="20px" />
        <ParagraphText
          color="#0a94cf"
          fontSize="md"
          paddingBottom="10px"
          as="h3"
        >
          IT企業、メーカーの
          <br />
          エンジニア職、技術職がメイン。
        </ParagraphText>
        <Text paddingBottom="10px" textAlign="left">
          機械・電気電子・情報・数物科学の理系学部生を求めており、自社独自の技術を持った企業が登録しています。また、学歴フィルターも一切ありません。
        </Text>
      </ListItem>
      <ListItem
        w="100%"
        maxW="320px"
        borderRadius="20px"
        padding="20px"
        mr="5px"
        filter="drop-shadow(0 0 10px rgba(0,0,0,.05))"
        bg="white"
      >
        <Image
          src={images.square2}
          width="56px"
          alt=""
          display="block"
          margin="-48px auto .8em"
        />
        <ParagraphText fontSize="1.2rem" as="h2">
          プロフィールを登録して
          <br />
          オファーを待つだけ
        </ParagraphText>
        <Image
          src={images.studentReceivingMail}
          width="280px"
          alt=""
          py="20px"
        />
        <ParagraphText
          color="#0a94cf"
          fontSize="md"
          paddingBottom="10px"
          as="h3"
        >
          理系学部生が書きやすい
          <br />
          シンプルなプロフィール構成。
        </ParagraphText>
        <Text paddingBottom="10px" textAlign="left">
          いきなり選考ではなく、カジュアル面談から始められます。プロフィールを作成するためのコンテンツも充実しています。
        </Text>
      </ListItem>
      {variant === 'interview' ? (
        <ListItem
          w="100%"
          maxW="320px"
          borderRadius="20px"
          padding="20px"
          filter="drop-shadow(0 0 10px rgba(0,0,0,.05))"
          bg="white"
        >
          <Image
            src={images.square3}
            width="56px"
            alt=""
            display="block"
            margin="-48px auto .8em"
          />
          <ParagraphText fontSize="1.2rem" as="h2">
            企業のリクルーターと
            <br />
            直接つながれる
          </ParagraphText>
          <Image src={images.casualInterview} width="280px" alt="" py="20px" />
          <ParagraphText
            color="#0a94cf"
            fontSize="md"
            paddingBottom="10px"
            as="h3"
          >
            採用担当者と直接話せるので
            <br />
            企業理解がどんどん深まる
          </ParagraphText>
          <Text paddingBottom="10px" textAlign="left">
            企業のリクルーターと直接接点を持つことができるから、気になる事も直接質問可能！だから効率的に企業理解が深まります。
          </Text>
        </ListItem>
      ) : (
        <ListItem
          w="100%"
          maxW="320px"
          borderRadius="20px"
          padding="20px"
          filter="drop-shadow(0 0 10px rgba(0,0,0,.05))"
          bg="white"
        >
          <Image
            src={images.square3}
            width="56px"
            alt=""
            display="block"
            margin="-48px auto .8em"
          />
          <ParagraphText fontSize="1.2rem" as="h2">
            大学1年生～3年生から
            <br />
            利用可能
          </ParagraphText>
          <Image src={images.casualInterview} width="280px" alt="" py="20px" />
          <ParagraphText
            color="#0a94cf"
            fontSize="md"
            paddingBottom="10px"
            as="h3"
          >
            「まずは情報収集から」
            <br />
            「インターン検討中」
          </ParagraphText>
          <Text paddingBottom="10px" textAlign="left">
            学年を問わず、企業のリクルーターと接点を持つことができます。早い段階から企業理解を深めたい方も歓迎しています。
          </Text>
        </ListItem>
      )}
    </List>
    <VStack w="100%" alignItems="center" paddingTop="30px">
      <SignUpButton variant={variant} onClick={scrollToForm} />
    </VStack>
  </Section>
);

export default ReasonSection;
